export enum CoordinateFormatEnum {
  DD = "dd",
  DMS = "dms",
}
